import React, { useState } from "react";
import { Add as AddIcon, AlarmOff as TimeOffIcon } from "@mui/icons-material";
import { endOfYear, startOfYear } from "date-fns";
import { PageTitle, DataGrid, FilterBar } from "../../components";
import { useResponsive, useUser } from "../../hooks";
import { useRequestModals } from "./Modals";
import { columns, hiddenColumnsMobile } from "./columns";
import { useEmployeeTimeInLieusQuery } from "./useTimeInLieuQuery";

const TEST_ID = "time-in-lieu";

export const TimeInLieu = () => {
  const user = useUser();
  const [filterUser, setFilterUser] = useState<string>(user?.id ?? "");
  const [dates, setDates] = useState<Interval | null>({
    start: startOfYear(new Date()),
    end: endOfYear(new Date()),
  });

  const handleUserSearch = (val: string) => {
    setFilterUser(val ? val : user?.id ?? "");
  };

  const { showCreateModal, showUpdateModal, showDeleteModal } =
    useRequestModals();
  const { isMd } = useResponsive();

  const { items, error, isPending } = useEmployeeTimeInLieusQuery(
    filterUser,
    dates
  );

  return (
    <>
      <PageTitle
        action={{
          label: "Time in Lieu",
          icon: <AddIcon />,
          onClick: () =>
            showCreateModal({
              timeInLieus: [],
              employeeID: filterUser,
            }),
          disabled: !filterUser,
        }}
        icon={<TimeOffIcon />}
        title="Time In Lieu"
        testID={TEST_ID}
      />

      <FilterBar
        employee={
          user && user?.isAdmin
            ? { value: filterUser || user.id, onChange: handleUserSearch }
            : undefined
        }
        dates={{
          value: dates,
          onChange: setDates,
          type: "year",
        }}
        testID="timeoff"
      />

      <DataGrid
        columns={columns({
          showUpdateModal,
          showDeleteModal,
          timeInLieus: items,
          employeeID: filterUser,
          maxDate: dates?.end ? new Date(dates.end) : new Date(),
          minDate: dates?.start ? new Date(dates.start) : new Date(),
        })}
        data={items ?? []}
        loading={isPending}
        emptyState={{
          title: "Time In Lieu",
          description: error?.message ?? "You have no time in lieu requests.",
          testID: TEST_ID,
        }}
        hideColumnSelector
        hideExport
        testID={TEST_ID}
        disableColumnMenu
        hideFooterPagination
        disableSelectionOnClick
        columnVisibility={isMd ? hiddenColumnsMobile : {}}
        sortModel={[
          {
            field: "startDate",
            sort: "asc",
          },
        ]}
      />
    </>
  );
};
